// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"445debd7","112":"7ca70961","186":"8f49242e","308":"8041516b","493":"b9b80bb5"}[chunkId] + ".chunk.js";
};